import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { IDismissBillAuditLog } from './types';
import {
  billDataReviewed,
  dismissBillAuditLog,
  persistBillsFilter,
} from './services';
import {
  IBillDataReviewedParams,
  IBillDataReviewedResponse,
  IBillsUserPersistPostBody,
  IBillsUserPersistResponse,
} from '../types';

export const useDismissBillAuditLogMutation = (
  options?: UseMutationOptions<AxiosResponse, AxiosError, IDismissBillAuditLog>,
) =>
  useMutation({
    mutationFn: dismissBillAuditLog,
    ...options,
  });

export const usePersistBillsFilterMutation = (
  options?: UseMutationOptions<
    IBillsUserPersistResponse,
    AxiosError,
    IBillsUserPersistPostBody
  >,
) =>
  useMutation<IBillsUserPersistResponse, AxiosError, IBillsUserPersistPostBody>(
    {
      mutationFn: persistBillsFilter,
      retry: false,
      ...options,
    },
  );

export const useBillDataReviewedMutation = (
  options?: UseMutationOptions<
    IBillDataReviewedResponse,
    AxiosError<{ message: string }>,
    IBillDataReviewedParams
  >,
) =>
  useMutation<
    IBillDataReviewedResponse,
    AxiosError<{ message: string }>,
    IBillDataReviewedParams
  >({
    mutationFn: billDataReviewed,
    retry: false,
    ...options,
  });
